import React, { useState } from 'react'
import { ContainerMiniLanding } from './style';
import { Button, Input } from '@prima-afp/prima-ui-design-system/dist/ui-components';
import useDeviceType from '../App/hooks/useDeviceType';
import { sendToData } from '../digital-transfers/constants/sendToDataLayer';
import { Typography } from "@prima-afp/prima-ui-design-system/dist/ui-components";
import { useReCaptcha } from 'modules/digital-transfers/hooks/useRecaptcha';


export const ContinueFlow = ({ onHandleClick }) => {
    const deviceType = useDeviceType();
    const [dni, setDni] = useState('')
    const [disabledButton, setDisabledButton] = useState(true)
  const { executeReCaptcha, ReCaptchaComponent } = useReCaptcha();

    const onChangeDni = (value) => {
        setDni(value);
        if (/^\d{8}$/.test(value) && /^\d*$/.test(value)) {
            setDisabledButton(false);
        } else {
            setDisabledButton(true);
        }
    }

    const handleClickInput = async () => {
        var payload = { section: "paso_1_continuar-traspaso", option: "Click en cada uno de los inputs" };
        sendToData(window.location.href, "input_click", "input_click", payload);
    };


    const onClick = async () => {
        const recaptchaToken = await executeReCaptcha();
        onHandleClick?.(dni, recaptchaToken);
    }

    return (
        <>
            <ReCaptchaComponent />
            <ContainerMiniLanding>
                <div className="content">
                    <div className="titleMain">
                        <Typography
                            align="left"
                            color="#ff4f00"
                            variant="h4"
                            bold
                        >
                            Continúa con tu trapaso
                        </Typography>
                    </div>
                    <div className="titleText">
                        <Typography
                            align="left"
                            color="#4e5258"
                            variant="bodyTextL"
                        >
                            {deviceType !== 'mobile' && <p>Te llevaremos al paso en el que te quedaste</p>}
                            {deviceType === 'mobile' && <p>Te llevaremos al paso en el que te quedaste, sólo ingresa tu documento de identidad:</p>}
                        </Typography>
                    </div>


                    <div className="input">

                        <div onClick={handleClickInput}>
                            <Input
                                addonOnClick={function Xs() { }}
                                editable
                                hintIcon
                                id="input"
                                isRequired
                                label={deviceType === 'mobile' ? null : "Ingresa tu documento de identidad"}
                                name="input"
                                onChange={onChangeDni}
                                placeholder="Ej. 12345678"
                                prefixAddon="DNI"
                                size="medium"
                                type="number"
                                value={dni}
                            />
                        </div>

                    </div>
                </div>
                <div className="contentButton">
                    <Button
                        disabled={disabledButton}
                        iconName=""
                        iconPosition="left"
                        label="Continuar"
                        onClick={onClick}
                        padding=""
                        size="large"
                        variant="primary"
                        width=""
                    />
                </div>
            </ContainerMiniLanding>
        </>
    )
}
